<template>
  <div>
    <div v-for="(item, index) in dataList" :key="item.id + index">
      <div class="wrap-style">
        <table border="1" class="table-style" width="100%">
          <tr>
            <td class="tac print-title" colspan="7">{{ item.businessTypeName }}MO票号：{{ item.moTicketCode }}</td>
          </tr>
          <tr>
            <td class="tac table-title">领料人</td>
            <td class="tac team-group-class">
              {{ item.teamGroupName }}
            </td>
            <td class="tac table-title">领料单号</td>
            <td class="tac" colspan="3">
              {{ item.requisitionCode }}
              <span v-if="item.isCombined==='Y'">合单</span>
            </td>
            <td class="tac" rowspan="4">
              <QrCode class="qr-code" id="moTicketPickMaterialQrCodeShow" :text="item.moTicketCode" width="120" height="120" />
            </td>
          </tr>
          <tr>
            <td class="tac table-title">领料部门</td>
            <td class="tac">
              {{ item.workshopDesc }}
            </td>
            <td class="tac table-title">计划单号</td>
            <td class="tac" colspan="3">{{ item.orderNo }}</td>
          </tr>
          <tr>
            <td class="tac table-title">工单号</td>
            <td class="tac">{{ item.upstreamWorkNumber }}</td>
            <td class="tac table-title">成品物料名称</td>
            <td class="tac" colspan="3">{{ item.assemblyItemName }}</td>
          </tr>
          <tr>
            <td class="tac table-title">单据编号</td>
            <td class="tac">{{ item.billNo }}</td>
            <td class="tac table-title">工单总数量</td>
            <td class="tac" colspan="3">{{ item.planQuantity }}</td>
          </tr>
          <tr>
            <td class="tac table-title">成品规格描述</td>
            <td class="tac" colspan="6">{{ item.specification }}</td>
          </tr>
          <tr>
            <td class="tac table-title" width="13%">物料编码</td>
            <td class="tac table-title" width="30%">物料名称</td>
            <td class="tac table-title" width="12%">派工数量（套）</td>
            <td class="tac table-title" width="14%">定量（米/平方英寸）</td>
            <td class="tac table-title" width="11%">合计</td>
            <td class="tac table-title" width="11%">领料数量</td>
            <td class="tac table-title">补料数量</td>
          </tr>
          <tr v-if="!item.detailList || item.detailList.length===0">
            <td class="tac" colspan="7">空</td>
          </tr>
          <tr v-for="(material, materialIndex) in item.detailList" :key="material.itemCode + materialIndex">
            <td class="tac">{{ material.itemCode }}</td>
            <td class="tac" >{{ material.itemName }}</td>
            <td class="tac">
              {{ material.planQuantity }}
            </td>
            <td class="tac" >{{ material.quantityPerAssembly }}</td>
            <td class="tac">{{ material.hj }}</td>
            <td class="tac">
              {{ material.llsl }}
            </td>
            <td class="tac">{{ material.blsl }}</td>
          </tr>
          <tr>
            <td class="tac table-title">备注</td>
            <td class="tac" colspan="6">
              {{ item.remark }}
            </td>
          </tr>
          <tr>
            <td class="tac table-title">退料</td>
            <td class="tac">
              {{ item.tbl }}
            </td>
            <td class="tac table-title">真皮批次</td>
            <td class="tac batch-text-lg" colspan="4">
              {{ item.zppc }}
            </td>
          </tr>
          <tr>
            <td class="tac table-title">实际用量</td>
            <td class="tac">
              {{ item.sjyl }}
            </td>
            <td class="tac table-title">仿皮批次</td>
            <td class="tac batch-text-lg" colspan="4">
              {{ item.fppc }}
            </td>
          </tr>
          <tr>
            <td class="tac table-title">计划生产时间</td>
            <td class="tac">
              {{ item.scheduledStartDate }}
            </td>
            <td class="tac table-title">工单交期</td>
            <td class="tac">{{ item.deliveryDate }}</td>
            <td class="tac table-title">完工时间</td>
            <td class="tac" colspan="2">
              {{ item.endTime }}
            </td>
          </tr>
          <tr>
            <td class="tac table-title" colspan="7">
              <div class="info">
                <div class="item">仓库主管:</div>
                <div class="item">车间主管:</div>
                <div class="item">收货人:</div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import QrCode from '@/components/QrCode/index.vue'

export default {
  name: 'PrintPickMaterial',
  components: { QrCode },
  data () {
    return {
      dataList: []
    }
  },
  methods: {
    show(dataList) {
      this.dataList = dataList
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="less" scoped>
.wrap-style{
  font-family: "黑体", "微软雅黑", "宋体", serif;
  color: #000;
  page-break-after: always;
  padding: 10px;
  font-size: 15px;
  table{
    border: 2px solid #000;
  }
}
.info{
  display: flex;
  justify-content: space-between;
  .item{
    text-align: left;
    padding-left: 4.2%;
    width: 33%;
  }
}
.team-group-class{
  font-size: 16px;
  font-weight: 600;
}
.print-title{
  font-weight: 600;
  font-size: 16px;
}
.table-title{
  font-weight: 600;
  font-size: 15px;
}
.table-style{
  width: 100%;
}
.tac{
  text-align: center;
}
.batch-text-lg {
  font-size: 28px;
}
tr{
  height: 30px;
}
td{
  padding: 0 5px;
}
.tip{
  margin-top: 10px;
}
</style>
